import FullPageLoader from './full-page-loader';
import ContainerLoader from './container-loader';
import Spinner from './spinner';

export interface LoaderProps {
  text?: string;
}

export { FullPageLoader, ContainerLoader, Spinner };
